"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._usergroupInviteReducer = exports._usergroupListReducer = void 0;
const _usergroupListReducer = require("../../modules/usergroup/list/reducers");
exports._usergroupListReducer = _usergroupListReducer;
const _usergroupInviteReducer = require("../../modules/usergroup/invite/reducers");
exports._usergroupInviteReducer = _usergroupInviteReducer;
//# sourceMappingURL=types.js.map